var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.561 16.2479C21.955 9.85494 28.816 6.02594 32.161 6.73094C32.054 6.20994 31.832 5.77394 31.496 5.43694C29.007 2.93994 20.99 6.90694 13.609 14.2959C6.228 21.6849 2.254 29.6939 4.742 32.1899C5.079 32.5269 5.515 32.7409 6.036 32.8559C5.339 29.5029 9.168 22.6419 15.561 16.2479Z",
    fill: "url(#paint0_linear_1_1399)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.522 18.208C23.915 11.815 30.776 7.98602 34.122 8.68302C34.015 8.16302 33.792 7.72602 33.456 7.38902C33.119 7.05202 32.682 6.83802 32.162 6.72302C28.816 6.02602 21.955 9.85502 15.562 16.248C9.16798 22.642 5.33898 29.503 6.04398 32.848C6.15098 33.369 6.37398 33.806 6.70998 34.143C7.04698 34.479 7.48298 34.693 8.00398 34.809C7.29998 31.463 11.128 24.601 17.522 18.208Z",
    fill: "url(#paint1_linear_1_1399)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.482 20.169C25.875 13.775 32.728 9.94698 36.082 10.643C35.975 10.123 35.752 9.68598 35.416 9.34898C35.079 9.01198 34.643 8.79898 34.122 8.68298C30.776 7.98598 23.915 11.815 17.522 18.208C11.128 24.602 7.30002 31.463 7.99602 34.808C8.10402 35.329 8.32602 35.766 8.66202 36.103C8.99902 36.44 9.43602 36.654 9.95702 36.769C9.26002 33.415 13.088 26.562 19.482 20.169Z",
    fill: "url(#paint2_linear_1_1399)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.442 22.129C27.835 15.735 34.696 11.907 38.042 12.604C37.935 12.083 37.713 11.647 37.376 11.31C37.039 10.973 36.6031 10.758 36.0821 10.643C32.736 9.94699 25.875 13.775 19.482 20.169C13.088 26.562 9.26005 33.415 9.95705 36.769C10.064 37.289 10.286 37.726 10.623 38.063C10.96 38.4 11.396 38.614 11.917 38.729C11.22 35.375 15.048 28.515 21.442 22.129Z",
    fill: "url(#paint3_linear_1_1399)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3951 24.0808C29.7881 17.6878 36.6491 13.8588 39.9951 14.5558C39.8881 14.0358 39.6651 13.5988 39.3291 13.2618C38.9921 12.9248 38.5551 12.7108 38.0351 12.5958C34.6891 11.8988 27.8281 15.7278 21.4351 22.1208C15.0411 28.5148 11.2121 35.3748 11.9091 38.7208C12.0161 39.2418 12.2391 39.6788 12.5751 40.0148C12.9121 40.3518 13.3491 40.5668 13.8691 40.6818C13.1721 37.3358 17.0091 30.4738 23.3951 24.0808Z",
    fill: "url(#paint4_linear_1_1399)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.355 26.042C31.748 19.648 38.609 15.819 41.955 16.516C41.848 15.996 41.625 15.559 41.289 15.222C40.952 14.885 40.516 14.671 39.995 14.556C36.649 13.859 29.788 17.688 23.395 24.081C17.009 30.475 13.172 37.336 13.877 40.681C13.984 41.202 14.207 41.639 14.543 41.976C14.88 42.313 15.316 42.527 15.837 42.642C15.133 39.296 18.961 32.435 25.355 26.042Z",
    fill: "url(#paint5_linear_1_1399)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.249 17.182C42.912 16.845 42.476 16.632 41.955 16.516C38.609 15.819 31.748 19.648 25.355 26.042C18.961 32.435 15.133 39.296 15.837 42.642C15.944 43.162 16.167 43.599 16.503 43.936C18.999 46.432 27.009 42.466 34.398 35.076C41.778 27.688 45.745 19.679 43.249 17.182Z",
    fill: "url(#paint6_linear_1_1399)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.561 16.2479C21.955 9.85494 28.816 6.02594 32.161 6.73094C32.054 6.20994 31.832 5.77394 31.496 5.43694C29.007 2.93994 20.99 6.90694 13.609 14.2959C6.228 21.6849 2.254 29.6939 4.742 32.1899C5.079 32.5269 5.515 32.7409 6.036 32.8559C5.339 29.5029 9.168 22.6419 15.561 16.2479ZM15.561 16.2479C21.955 9.85494 28.816 6.02594 32.161 6.72294C32.682 6.83794 33.119 7.05294 33.456 7.38894C33.793 7.72594 34.015 8.16294 34.122 8.68294M34.122 8.68294C30.776 7.98594 23.915 11.8149 17.522 18.2089M34.122 8.68294C34.642 8.79794 35.079 9.01294 35.416 9.34894C35.753 9.68594 35.975 10.1229 36.082 10.6429M15.562 16.2479C9.168 22.6419 5.339 29.5029 6.044 32.8479C6.151 33.3689 6.374 33.8059 6.71 34.1429C7.047 34.4789 7.483 34.6929 8.004 34.8089C7.3 31.4629 11.128 24.6019 17.522 18.2089M17.522 18.2089C11.128 24.6029 7.3 31.4629 7.996 34.8079C8.104 35.3289 8.326 35.7659 8.662 36.1029C8.999 36.4399 9.436 36.6539 9.957 36.7689M9.957 36.7689C9.26 33.4149 13.088 26.5619 19.482 20.1689M9.957 36.7689C10.063 37.2899 10.286 37.7259 10.623 38.0629C10.96 38.3989 11.396 38.6139 11.917 38.7289C11.22 35.3749 15.048 28.5149 21.442 22.1289C27.835 15.7349 34.696 11.9069 38.042 12.6039C37.936 12.0829 37.713 11.6469 37.376 11.3099C37.039 10.9729 36.602 10.7579 36.082 10.6429M36.082 10.6429C32.728 9.94694 25.875 13.7749 19.482 20.1689M36.082 10.6429C32.736 9.94694 25.875 13.7749 19.482 20.1689M23.395 24.0809C29.788 17.6879 36.649 13.8589 39.995 14.5559M23.395 24.0809C17.009 30.4749 13.172 37.3359 13.869 40.6809C13.349 40.5669 12.912 40.3519 12.575 40.0149C12.238 39.6789 12.016 39.2419 11.909 38.7209C11.212 35.3749 15.041 28.5149 21.434 22.1209C27.828 15.7279 34.688 11.8989 38.034 12.5959C38.555 12.7109 38.992 12.9259 39.329 13.2619C39.666 13.5989 39.888 14.0349 39.995 14.5559M23.395 24.0809C17.009 30.4749 13.172 37.3359 13.877 40.6809C13.984 41.2019 14.207 41.6389 14.543 41.9759C14.88 42.3129 15.316 42.5269 15.837 42.6419M39.995 14.5559C40.515 14.6709 40.952 14.8859 41.289 15.2219C41.626 15.5589 41.848 15.9959 41.955 16.5159M15.837 42.6419C15.133 39.2959 18.961 32.4349 25.355 26.0419C31.748 19.6479 38.609 15.8189 41.955 16.5159M15.837 42.6419C15.944 43.1619 16.166 43.5989 16.503 43.9359C18.999 46.4319 27.008 42.4659 34.398 35.0769C41.779 27.6879 45.745 19.6789 43.249 17.1819C42.912 16.8459 42.475 16.6309 41.955 16.5159",
    stroke: "#18181B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1399",
    x1: 23.998,
    y1: 4.68994,
    x2: 23.998,
    y2: 44.6829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3FFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1399",
    x1: 23.998,
    y1: 4.69002,
    x2: 23.998,
    y2: 44.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3FFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_1399",
    x1: 23.998,
    y1: 4.68998,
    x2: 23.998,
    y2: 44.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3FFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_1399",
    x1: 23.998,
    y1: 4.68999,
    x2: 23.998,
    y2: 44.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3FFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_1399",
    x1: 23.9981,
    y1: 4.68983,
    x2: 23.9981,
    y2: 44.6828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3FFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_1399",
    x1: 23.998,
    y1: 4.69003,
    x2: 23.998,
    y2: 44.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3FFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_1399",
    x1: 23.998,
    y1: 4.68999,
    x2: 23.998,
    y2: 44.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3FFAF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.689941)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomized);
export default __webpack_public_path__ + "static/media/customized.5b9abc35d151db2d05782f638320b238.svg";
export { ForwardRef as ReactComponent };